import React, { useState } from 'react';
import { Form, Row, Col, Button, Collapse } from 'react-bootstrap';
import { FaSearch, FaChevronDown, FaChevronUp } from 'react-icons/fa';

const LotFilter = ({ onFilter, onClear }) => {
  const [description, setDescription] = useState('');
  const [customer, setCustomer] = useState('');
  const [product, setProduct] = useState('');
  const [harvest, setHarvest] = useState('');
  const [farm, setFarm] = useState('');
  const [silo, setSilo] = useState('');
  const [open, setOpen] = useState(true);

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter({
      description: description || undefined,
      customer: customer || undefined,
      product: product || undefined,
      harvest: harvest || undefined,
      farm: farm || undefined,
      silo: silo || undefined,
    });
  };

  const handleClear = () => {
    setDescription('');
    setCustomer('');
    setProduct('');
    setHarvest('');
    setFarm('');
    setSilo('');
    onClear();
  };

  const handleToggle = () => {
    setOpen(!open);
    if (open) {
      handleClear();
    }
  };

  return (
    <div
      style={{
        border: open ? '1px solid black' : 'none',
        borderRadius: '5px',
        padding: open ? '10px' : '0px',
        marginBottom: '20px',
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <h6
        className="text-center mb-3 d-flex align-items-center justify-content-center"
        style={{ cursor: 'pointer' }}
        onClick={handleToggle}
      >
        Filtros Avançados{' '}
        {open ? <FaChevronUp className="ms-2" /> : <FaChevronDown className="ms-2" />}
      </h6>
      <Collapse in={open}>
        <div>
          <Form
            onSubmit={(e) => {
              e.stopPropagation();
              handleSubmit(e);
            }}
          >
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="description" className="mb-3">
                  <Form.Label className="mb-1">Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Descrição"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="customer" className="mb-3">
                  <Form.Label className="mb-1">Cliente</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Cliente"
                    value={customer}
                    onChange={(e) => setCustomer(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="product" className="mb-3">
                  <Form.Label className="mb-1">Produto</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Produto"
                    value={product}
                    onChange={(e) => setProduct(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md={4}>
                <Form.Group controlId="harvest" className="mb-3">
                  <Form.Label className="mb-1">Safra</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Safra"
                    value={harvest}
                    onChange={(e) => setHarvest(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="farm" className="mb-3">
                  <Form.Label className="mb-1">Fazenda</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Fazenda"
                    value={farm}
                    onChange={(e) => setFarm(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group controlId="silo" className="mb-3">
                  <Form.Label className="mb-1">Silo</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Silo"
                    value={silo}
                    onChange={(e) => setSilo(e.target.value)}
                    autoComplete='off'
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} className="d-flex justify-content-start">
                <Button
                variant="primary"
                type="submit"
                className="button-custom d-flex align-items-center me-2"
                >
                <FaSearch className="me-2" /> Pesquisar
                </Button>
                <Button
                variant="secondary"
                onClick={handleClear}
                className="d-flex align-items-center"
                >
                Limpar
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Collapse>
    </div>
  );
};

export default LotFilter;